import { Component, ElementRef, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Globle } from 'src/assets/globle';
import { ReportsService } from '../reports.service';

import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { UserTrans } from '../userTrans.model';
import { Users } from 'src/app/options/users/users.model';
import { OptionService } from 'src/app/options/option.service';
import { LocalStorageService } from 'ngx-webstorage';
import { ExportexcelService } from '../exportexcel.service';
import { Observable } from 'rxjs';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-depositsusertrans',
  templateUrl: './depositsusertrans.component.html',
  styleUrls: ['./depositsusertrans.component.css']
})
export class DepositsusertransComponent implements OnInit {

  reports: UserTrans[] = [];
  users: Users[] = [];
  displayedColumns: string[] = [];
  dataSource!: MatTableDataSource<UserTrans>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  public contentRef1!: TemplateRef<any>;
  @ViewChild('fromDate') fromDate!: ElementRef;
  @ViewChild('toDate') toDate!: ElementRef;

  spinnerOverlay = false;
  selectedUser!: string;
  lang = 'en';
  reportObj: UserTrans = {} as UserTrans;
  pageSize = 100;
  filteredOptions!: Observable<Users[]>;
  searchUsers = new FormControl();

  constructor(private service: ReportsService,
    private optionService: OptionService,
    private globle: Globle,
    private dialog: MatDialog,
    private excelService: ExportexcelService,
    private localStorage: LocalStorageService) { }

  ngOnInit() {
    this.displayedColumns = ['date', 'fullName', 'userPhone', 'amount', "createBy", 'prevUserBallance', 'currUserBallance'];
    this.pageSize = this.globle.pageSize;
    this.getUsers();
  }

  getUsers() {
    let userId = this.localStorage.retrieve("userInfo").userId
    this.optionService.getAllCustomers(userId).subscribe(data => {
      this.users = data
      var user = {} as Users;
      user.fullName = "الجميع";
      user.id = "0";
      this.users.unshift(user);
      this.autoCompleatFilter();
    }, error => {
      console.log(error)
    })
  }

  autoCompleatFilter() {
    this.filteredOptions = this.searchUsers.valueChanges
      .pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value.name),
        map(name => name ? this._filter(name) : this.users.slice())
      );
  }

  private _filter(name: string): Users[] {
    const filterValue = name.toLowerCase();

    return this.users.filter(option => option.fullName.toLowerCase().indexOf(filterValue) === 0);
  }

  displayFn(user: Users): string {
    return user && user.fullName ? user.fullName : '';
  }

  selectUserChange(value: any) {
    this.selectedUser = value.id;
  }


  get() {
    this.spinnerOverlay = true;
    this.service.getUserTransDeposits(this.selectedUser, this.fromDate.nativeElement.value, this.toDate.nativeElement.value).subscribe(data => {

      this.reports = data;

      this.dataSource = new MatTableDataSource(this.reports);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
        this.reports = [];
        this.dataSource = new MatTableDataSource(this.reports);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      })
  }

  onApply() {
    this.get();
  }

  Print() {

    const doc = new jsPDF({ filters: ["ASCIIHexEncode"] });

    doc.addFileToVFS("../../assets/Amiri/Amiri-Regular.ttf", this.globle.AmiriRegular);
    doc.addFont("../../assets/Amiri/Amiri-Regular.ttf", "Amiri", "normal");

    doc.setFont("Amiri");

    doc.setFontSize(18);
    doc.setTextColor(40);
    //doc.setFont("",'normal');

    doc.text("كشف حركات مستخدم ", 90, 10);
    doc.text("_________________________________", 50, 12);

    // set font
    doc.setFontSize(10);
    doc.viewerPreferences({ "Direction": "L2R" }, true);

    let userName = this.users.find(x => x.id == this.selectedUser)?.fullName != null ?
      this.users.find(x => x.id == this.selectedUser)?.fullName :
      this.users.find(x => x.id == this.selectedUser)?.userName;

    doc.text(" المستخدم : " + userName, 150, 20, {
      isOutputRtl: true,
    });

    //autoTable({ html: '#orderProductTable', margin: { top: 30 }, styles: { font: "Amiri" } });
    autoTable(doc, { html: '#userTransTable', margin: { top: 30 }, styles: { font: "Amiri" } });
    //doc.save("test.pdf");
    doc.output('dataurlnewwindow');
  }

  exportAsXLSX(): void {
    var exportList = [];
    for (let i = 0; i < this.reports.length; i++) {
      var obj = {
        "التاريخ": this.reports[i].date,
        "الحركة": this.reports[i].transType,
        " المبلغ": this.reports[i].amount,
        "المودع ": this.reports[i].createBy,
      }

      exportList.push(obj);
    }
    this.excelService.exportAsExcelFile(exportList, 'تقرير ايداعات مستخدم');
  }
}
